/**
 * Gestione Dropdown multilivello per Offcanvas Mobile
 * Impedisce a Bootstrap di chiudere il menu padre quando si clicca su un figlio di secondo livello.
 */
export function initMobileMultilevelMenu() {
    const offcanvasMobile = document.getElementById('offcanvas-menu-mobile');
    if (!offcanvasMobile) return;

    // Selezioniamo tutti i link che hanno un sottomenu (dropdown-toggle o menu-item-has-children)
    // Cerchiamo sia i padri (.nav-link) che i figli (.dropdown-item) che contengono una <ul>
    const dropdownToggles = offcanvasMobile.querySelectorAll('.menu-item-has-children > a');

    dropdownToggles.forEach(toggle => {
        // Rimuoviamo gli attributi di Bootstrap per prendere il controllo totale
        toggle.removeAttribute('data-bs-toggle');
        toggle.removeAttribute('data-toggle');
        
        // Se è un link di sottomenu (Livello 2), aggiungiamo una classe per lo stile cursore se serve
        if (toggle.classList.contains('dropdown-item')) {
            toggle.style.cursor = 'pointer';
        }

        toggle.addEventListener('click', function(e) {
            const nextSubmenu = this.nextElementSibling;

            // Verifichiamo che l'elemento successivo sia effettivamente il sottomenu <ul>
            if (nextSubmenu && nextSubmenu.tagName === 'UL') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const isOpen = nextSubmenu.classList.contains('show');
                
                // Toggle manuale delle classi
                if (!isOpen) {
                    nextSubmenu.classList.add('show');
                    this.classList.add('show');
                    this.setAttribute('aria-expanded', 'true');
                    
                    // Forza ridisegno per alcuni browser mobile
                    nextSubmenu.style.display = 'block';
                } else {
                    nextSubmenu.classList.remove('show');
                    this.classList.remove('show');
                    this.setAttribute('aria-expanded', 'false');
                    
                    nextSubmenu.style.display = 'none';
                }
            }
        });
    });
}
